import api from "@/api/api";
import { dictionary } from "@/shared/services/dictionary";
import { isNull } from "@/shared/utils/utils";
import moment from "moment";
import {
  Field,
  Dialog,
  Icon,
  CellGroup,
  DatetimePicker,
  Popup,
  Form,
  Uploader,
  Button,
  DropdownMenu,
  DropdownItem,
  Area,
} from "vant";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Area.name]: Area,
  },
})
export default class MyInfo extends Vue {
  // 正在提交
  submitting = false;
  openId = "";
  isPool = 0; // 人才库进入（1）或招聘进入（0）
  resumeInfo: any = {}; // 简历信息
  resumeId: any = "";

  sexOptions: object[] = [
    { text: "男", value: 1 },
    { text: "女", value: 2 },
  ];
  diseasesOptions: object[] = [
    { text: "有", value: 'true' },
    { text: "无", value: 'false' },
  ];
  // marriagePlanOptions: any[] = [
  //   { text: "有", value: "true" },
  //   { text: "无", value: "false" },
  // ];
  // birthPlanOptions: any[] = [
  //   { text: "有", value: "true" },
  //   { text: "无", value: "false" },
  // ];
  // 日期弹窗的值
  dateValues: any = {};
  // 日期弹窗的状态
  dateShowState: any = {};
  // 地址弹窗的状态
  areaShowState: any = {};
  // 地址控件的值
  areaValues: any = {};

  // 政治面貌
  politicsTypes: any[] = [];
  // 学历选项
  educateTypes: any[] = [];
  // 婚育情况
  marriageStates: any[] = [];

  areaList: any = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    province_list: {},
    // eslint-disable-next-line @typescript-eslint/camelcase
    city_list: {},
  };
  applicationSources: any[] = []; // 应聘信息来源
  documentTypes: any[] = []; // 证件类型
  isErrorMessage = "";
  isMsg = "";
  ErrorMsg = "";
  // idCardTypeName = /^\d{15}|\d{}18$/;
  idCardTypeName = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
  phoneNumberName = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  mailNumberName = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  isChannelRemarkShow: boolean|null = false; // 是否展示渠道说明
  testName: any = {}; // 非空校验
  status: any[] = []; // 求职状态
  arrivalTime: any[] = []; // 到岗时间
  created() {
    this.isPool = Number(sessionStorage.getItem("isPool"))??0;
    const wechatUser = JSON.parse(sessionStorage.getItem("wechatUser") || "{}");
    this.openId = wechatUser.openid;
    console.log(this.openId);
    this.resumeId = this.$route.query.resumeId || "";
    this.initDictionary();
    this.initAreaOption();
  }

  mounted() {
    if (this.resumeId) {
      this.initResumeInfo();
    }
  }

  onChange(type: any, name: any) {
    if (!this.resumeInfo[type]) {
      this.testName[type] = name + "为必填项";
    } else if (this.resumeInfo[type]) {
      this.testName[type] = "";
    }
  }

  onAreaChange(type: any, name: any) {
    if (!this.areaValues[type]) {
      this.testName[type] = name + "为必填项";
    } else if (this.areaValues[type]) {
      this.testName[type] = "";
    }
  }

  idCardNumberChange() {
    if (
      this.resumeInfo.idCardNumber &&
      !this.idCardTypeName.test(this.resumeInfo.idCardNumber)
    ) {
      this.isErrorMessage = "请输入正确格式证件号";
      // Dialog({ message: "请输入正确格式证件号" });
      // return false;
    } else {
      this.isErrorMessage = "";
    }
  }

  phoneNumberChange() {
    if (
      this.resumeInfo.phoneNumber &&
      !this.phoneNumberName.test(this.resumeInfo.phoneNumber)
    ) {
      this.ErrorMsg = "请输入正确格式手机号";
      // Dialog({ message: "请输入正确格式手机号" });
      // return false;
    } else {
      this.ErrorMsg = "";
    }
  }

  mailNumberChange() {
    if (
      this.resumeInfo.mailNumber &&
      !this.mailNumberName.test(this.resumeInfo.mailNumber)
    ) {
      this.isMsg = "请输入正确格式电子邮箱";
      // Dialog({ message: "请输入正确格式电子邮箱" });
      // return false;
    } else {
      this.isMsg = "";
    }
  }
  // 初始化简历
  initResumeInfo() {
    const resumeApi =
      this.isPool === 1 ? api.getTalentPoolResume : api.getRecruitResume;
    resumeApi({ openId: this.openId, id: this.resumeId }).then((res: any) => {
      this.resumeInfo = res.resumeInfo;
      // 证件类型赋初始值
      if (!this.resumeInfo.idCardTypeName) {
        this.resumeInfo.idCardType = dictionary.idCard;
        this.resumeInfo.idCardTypeName = this.documentTypes.find(
          (item: any) => item.value === this.resumeInfo.idCardType
        )?.text;
      }
      this.resumeInfo.isDiseases = this.resumeInfo.isDiseases.toString();
      this.initResumeArea();
      this.initTimeValues();
    });
  }

  // 初始化时间控件值
  initTimeValues() {
    if (this.resumeInfo.birthdayDate) {
      this.resumeInfo.birthdayDate = moment(
        this.resumeInfo.birthdayDate
      ).format("YYYY-MM-DD");
    }
    if (this.resumeInfo.graduateDate) {
      this.resumeInfo.graduateDate = moment(
        this.resumeInfo.graduateDate
      ).format("YYYY-MM-DD");
    }
  }

  // 初始化地址选项
  initAreaOption() {
    api.getProvinceAndCity().then((res: any) => {
      const areas: any[] = res.allDistricts || [];
      areas.forEach((area: any) => {
        if (area.levelNo === 1) {
          this.areaList.province_list[area.code] = area.name;
        }
        if (area.levelNo === 2) {
          this.areaList.city_list[area.code] = area.name;
        }
      });
      if (this.resumeInfo.id) {
        this.initResumeArea();
      }
    });
  }

  // 初始化字典值
  initDictionary() {
    // 政治面貌
    api.getDictionaries([dictionary.politicsType]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.politicsTypes = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
    // 学历选项
    api.getDictionaries([dictionary.educateType]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.educateTypes = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
    // 婚育状况
    api.getDictionaries([dictionary.marriageState]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.marriageStates = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
    // 应聘信息来源
    api.getDictionaries([dictionary.applicationSource]).then((res: any) => {
      const datas: any[] = res.data || [];
      const applicationSources = datas.map((d) => {
        return {
          text: d.name,
          value: d.id,
        };
      });
      this.applicationSources = applicationSources.filter((item: any) => {
        return (
          item.value !== dictionary.secondInterview &&
          item.value !== dictionary.regularOther &&
          item.value !== dictionary.regularPart
        );
      });
    });
    // 证件类型
    api.getDictionaries([dictionary.documentType]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.documentTypes = datas.map((d) => {
        return {
          text: d.name,
          value: d.id,
        };
      });
    });
    // 求职状态
    api.getDictionaries([dictionary.lookForStatus]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.status = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
    // 到岗时间
    api.getDictionaries([dictionary.arrivalTimes]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.arrivalTime = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
  }

  onChannelTypeChange(event: any) {
    if (event && event === dictionary.applicationSourceOther) {
      this.isChannelRemarkShow = true;
    } else {
      this.isChannelRemarkShow = false;
    }
  }

  // 日期输入框点击
  timeControlOnClicked(field: string) {
    let date = this.resumeInfo[field];
    if (isNull(date)) {
      date = new Date();
    }
    this.dateValues[field] = new Date(date);
    this.dateShowState[field] = true;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击取消
  timePopupOnCancel(field: string) {
    this.dateShowState[field] = false;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击确认
  timePopupOnConfirm(val: any, field: string) {
    this.resumeInfo[field] = moment(val).format("YYYY-MM-DD");
    this.timePopupOnCancel(field);
  }

  // 地址控件点击
  onAreaFieldClick(field: string) {
    this.areaShowState[field] = true;
    this.areaShowState = Object.assign({}, this.areaShowState);
    console.log(this.areaShowState);
  }

  // 地址控件确认
  onAreaConfirm(event: any, field: string) {
    this.areaValues[field] = event[0].name + "/" + event[1].name;
    if (field === "birthPlace") {
      this.resumeInfo["birthPlaceCode"] = event[1].code;
    }
    if (field === "liveCity") {
      this.resumeInfo["liveCityCode"] = event[1].code;
      this.resumeInfo["liveProCode"] = event[0].code;
    }
    if (field === "hometownCity") {
      this.resumeInfo["hometownCityCode"] = event[1].code;
    }
    if (field === "houseHoldPlace") {
      this.resumeInfo["houseHoldPlaceCode"] = event[1].code;
    }
    console.log(event);
    this.onAreaCancle(field);
  }

  // 初始化简历的地址控件值
  initResumeArea() {
    if (this.resumeInfo["birthPlaceCode"]) {
      const cityCode = this.resumeInfo["birthPlaceCode"];
      const proCode = this.getProCodeByCityCode(cityCode);
      this.areaValues["birthPlace"] =
        this.areaList.province_list[proCode] +
        "/" +
        this.areaList.city_list[cityCode];
    }
    if (this.resumeInfo["liveCityCode"]) {
      const cityCode = this.resumeInfo["liveCityCode"];
      const proCode = this.getProCodeByCityCode(cityCode);
      this.areaValues["liveCity"] =
        this.areaList.province_list[proCode] +
        "/" +
        this.areaList.city_list[cityCode];
    }
    if (this.resumeInfo["hometownCityCode"]) {
      const cityCode = this.resumeInfo["hometownCityCode"];
      const proCode = this.getProCodeByCityCode(cityCode);
      this.areaValues["hometownCity"] =
        this.areaList.province_list[proCode] +
        "/" +
        this.areaList.city_list[cityCode];
    }
    if (this.resumeInfo["houseHoldPlaceCode"]) {
      const cityCode = this.resumeInfo["houseHoldPlaceCode"];
      const proCode = this.getProCodeByCityCode(cityCode);
      this.areaValues["houseHoldPlace"] =
        this.areaList.province_list[proCode] +
        "/" +
        this.areaList.city_list[cityCode];
    }
    this.areaValues = Object.assign({}, this.areaValues);
  }

  /**
   * 根据城市的 Code 获取对应省份的 Code
   */
  getProCodeByCityCode(cityCode: string): string {
    if (!cityCode) {
      return "";
    }
    const proCode = cityCode.substr(0, 2) + "0000";
    return proCode;
  }

  // 地址控件取消
  onAreaCancle(field: any) {
    this.areaShowState[field] = false;
    this.areaShowState = Object.assign({}, this.areaShowState);
  }

  validat(): boolean {
    const validator: any = {
      channelType: {
        name: "应聘信息来源",
      },
      userName: {
        name: "姓名",
      },
      sexType: {
        name: "性别",
      },
      birthdayDate: {
        name: "出生日期",
      },
      age: {
        name: "年龄",
      },
      politicsType: {
        name: "政治面貌",
      },
      isDiseases: {
        name: "有无遗传/传染性/重大疾病史",
      },
      marriageState: {
        name: "婚育状态",
      },
      idCardType: {
        name: "证件类型",
      },
      idCardNumber: {
        name: "证件号",
      },
      height: {
        name: "身高",
      },
      weight: {
        name: "体重",
      },
      phoneNumber: {
        name: "手机号码",
      },
      mailNumber: {
        name: "电子邮箱",
      },
    };
    const keys = Object.keys(validator);
    for (const key of keys) {
      const value = this.resumeInfo[key];
      if (isNull(value)) {
        Dialog({ message: validator[key].name + "为必填项" });
        return false;
      }
    }
    return true;
  }

  // 提交
  submit() {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    if (!this.validat()) {
      this.submitting = false;
      return;
    }
    // if(!this.idCardNumberChange()){
    //   return;
    // }
    // if(!this.phoneNumberChange()){
    //   return;
    // }
    // if(!this.mailNumberChange()){
    //   return;
    // }
    if (this.isChannelRemarkShow && this.resumeInfo.channelRemark) {
      Dialog({ message: "应聘信息来源说明为必填项" });
      this.submitting = false;
      return;
    }
    if (isNull(this.areaValues.hometownCity)) {
      Dialog({ message: "籍贯为必填项" });
      this.submitting = false;
      return;
    }
    if (isNull(this.areaValues.houseHoldPlace)) {
      Dialog({ message: "户口所在地为必填项" });
      this.submitting = false;
      return;
    }
    if (isNull(this.areaValues.liveCity)) {
      Dialog({ message: "家庭常住地为必填项" });
      this.submitting = false;
      return;
    }

    // name赋值
    this.getName();

    if (this.resumeId) {
      this.editResumeInfo();
    } else {
      this.addResumeInfo();
    }
  }

  addResumeInfo() {
    const isPool = sessionStorage.getItem("isPool");
    const addResumeApi =
      isPool === "1" ? api.addTalentPoolResume : api.addRecruitResume;

    const entity = {
      openId: this.openId,
      resumeInfo: this.resumeInfo,
    };
    this.resumeInfo.educates = [];
    this.resumeInfo.files = [];
    this.resumeInfo.members = [];
    this.resumeInfo.positions = [];
    this.resumeInfo.projects = [];
    this.resumeInfo.rewards = [];
    this.resumeInfo.skills = [];
    this.resumeInfo.trains = [];
    this.resumeInfo.workExperiences = [];
    this.resumeInfo.workPlaces = [];
    this.resumeInfo.trades = [];
    addResumeApi(entity).then((res) => {
      this.$router.push("/my-info");
    }).finally(() => {
      this.submitting = false;
    });
  }

  // 根据id获取相应name
  getName() {
    // 应聘信息来源
    if (this.resumeInfo.channelType) {
      this.resumeInfo.channelTypeName = this.applicationSources.find(
        (item: any) => item.value === this.resumeInfo.channelType
      ).text;
    }
    if (this.resumeInfo.idCardType) {
      this.resumeInfo.idCardTypeName = this.documentTypes.find(
        (item: any) => item.value === this.resumeInfo.idCardType
      )?.text;
    }
  }
  editResumeInfo() {
    const isPool = sessionStorage.getItem("isPool");
    const editResumeApi =
      isPool === "1" ? api.editTalentPoolResume : api.editRecruitResume;

    const entity = {
      openId: this.openId,
      resumeInfo: this.resumeInfo,
    };
    editResumeApi(entity).then((res) => {
      this.$router.push(`/resume-detail?resumeId=${this.resumeId}`);
    }).finally(() => { 
      this.submitting = false;
    });
  }
}
